import { takeLatest } from 'redux-saga/effects';
import { FETCH_CORPORATE_SALES_PURCHASE_ORDER_REQUEST } from '../../redux/modules/corporateSalesPurchaseOrder/corporateSalesPurchaseOrder-actions';
import fetchCorporateSalesPurchaseWorker from './corporateSalesPOWorkerSaga';

function* fetchCorporateSalesPurchaseOrderWatcher() {
    yield takeLatest(FETCH_CORPORATE_SALES_PURCHASE_ORDER_REQUEST, fetchCorporateSalesPurchaseWorker);
}

export default fetchCorporateSalesPurchaseOrderWatcher;
